import React from 'react'
import { withAppContextDecorators } from '@/common/AppContext';
import { Breadcrumb } from 'antd';
import './index.less'
import {useHistory} from "react-router-dom";
const ComplianceConcept = (props) => {
    const history = useHistory()
    const contactList = {
        contactLeft: {
            text: [
                "合规理念",
                "Compliance Pursuance",
                "公司确立“本分诚信、追求至善、合规共进、筑梦同行”为核心的合规文化理念，倡导“主动合规、人人合规、全程合规” 所有员工应忠实践行合规理念。"
            ]
        },
        contactRight: {
            text: [
                "合规科技",
                "Technology In Compliance",
                "智能风控系统（AI质检+人工复核、智能语音转化、实时风险监督）<br/>智能管理系统（智能风控RPA管理系统、智能工作手机、素材审核系统）"
            ]
        }
    }

    return <div id="complianceConcept">
        <div className={'breadcrumb-con warp'}>
            <Breadcrumb separator=">">
                <Breadcrumb.Item onClick={()=>{history.push({pathname:'/index'})}}>首页</Breadcrumb.Item>
                <Breadcrumb.Item>合规理念</Breadcrumb.Item>
            </Breadcrumb>
        </div>

        <div className={'centerBox warp'}>
            <div className={'list'}>
                <div className={'list-con left'}>
                    <div className={'list-title'}>
                        <h2>{contactList.contactLeft.text[0]}</h2>
                        <p>{contactList.contactLeft.text[1]}</p>
                    </div>
                    <div className={'list-describe'}>{contactList.contactLeft.text[2]}</div>
                </div>
                <img src={require(`@/assets/images/compliance/img4.png`)} />
            </div>

            <div className={'list'}>
                <img src={require(`@/assets/images/compliance/img5.png`)} />
                <div className={'list-con right' }>
                    <div className={'list-title'}>
                        <h2>{contactList.contactRight.text[0]}</h2>
                        <p>{contactList.contactRight.text[1]}</p>
                    </div>
                    <div className={'list-describe'} dangerouslySetInnerHTML={{__html:contactList.contactRight.text[2]}}></div>
                </div>
            </div>
        </div>
    </div>
}
export default withAppContextDecorators(ComplianceConcept)
